<template>
  <div class="int-wrap">
    <img
      class="int-logo mx-auto mx-md-0 mb-4"
      src="../../assets/img/rabota/logo-rabota-huntica.svg"
      alt=""
    >
    <template v-if="step < 3">
      <VStepper v-model="step" class="int-stepper">
        <VStepperHeader class="int-stepper__steps">
          <VStepperStep class="int-stepper__step-item" step="1" color="#0A82D9" />
          <VStepperStep class="int-stepper__step-item" step="2" />
        </VStepperHeader>
        <h1 class="int-head text-center">
          {{ $t(`title${step}`) }}
        </h1>
        <div class="int-head-text text-center" v-html="$t(`description${step}`)" />
        <VStepperItems>
          <VStepperContent step="1" class="pa-1">
            <IntegrationsWizardRegistration v-if="step === 1" @next="next" />
          </VStepperContent>
          <VStepperContent step="2" class="pa-1">
            <IntegrationsVacancyList v-if="step === 2" @next="next" @saved="next" />
          </VStepperContent>
        </VStepperItems>
      </VStepper>
    </template>
    <IntegrationsWizardDone v-else :vacancy-id="1" />
    <v-overlay :value="loading" />
  </div>
</template>

<script>
import IntegrationsWizardRegistration from '@/components/Integrations/IntegrationWizard/IntegrationsWizardRegistration.vue';
import IntegrationsVacancyList from '@/components/Integrations/IntegrationsVacancyList.vue';
import IntegrationsWizardDone from '@/components/Integrations/IntegrationWizard/IntegrationsWizardDone.vue';
import useUser from '@/compositions/useUser';
import { ref } from '@vue/composition-api';
import useValidation from '@/compositions/useValidation';

export default {
  name: 'IntegrationsWizard',
  components: {
    IntegrationsWizardDone,
    IntegrationsVacancyList,
    IntegrationsWizardRegistration,
  },
  setup(_, { root }) {
    const currentStep = localStorage.getItem('integrationWizardStep');
    const { company, currentUser } = useUser();
    const { loading } = useValidation();
    const step = ref(Number.parseInt(currentStep, 10) || 1);

    if (currentUser?.value && step.value === 1) {
      step.value = 2;
    }

    if (step.value === 3) {
      root.$router.push({
        name: 'dashboard',
      });
    }

    function next() {
      step.value += 1;
      localStorage.setItem('integrationWizardStep', step.value);
    }

    return {
      company,
      currentUser,
      loading,
      next,
      step,
    };
  },
};
</script>

<style lang="scss" scoped>
  .int-wrap {
    position: relative;
    padding-top: 0.25rem;
  }
  .int-logo {
    max-width: 17.375rem;
    position: absolute;
    top: 0.4375rem;
    left: 1.125rem;
  }
  .v-stepper.theme--light.int-stepper {
    background: transparent;
    box-shadow: none;
  }
  .int-stepper {
    &__steps {
      max-width: 20.75rem;
      margin: 0 auto 2px auto;
      box-shadow: none;
      position: relative;

      &:before {
        content: "";
        width: 100%;
        opacity: 0.5;
        border-top: 1px dashed rgba(0, 0, 0, 0.5);
        position: absolute;
        left: 0;
        top: 2.21875rem;
        z-index: 1;
      }
    }

    &__step-item {
      &:last-child {
        margin-right: 0;
      }
    }

    &__step-item-field {
      width: 2.5rem;
      height: 2.5rem;
      background: red;
    }
  }
  .int-head {
    font-size: 2.125rem;
    font-weight: bold;
    line-height: 1.32;
    color: #091A35;
    margin-bottom: 0.75rem;
  }
  .int-head-text {
    font-size: 1.0625rem;
    line-height: 1.53;
    text-align: center;
    color: #091A35;
    margin-bottom: 1.25rem;
  }

  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    .int-logo {
      max-width: 16rem;
      position: static;
    }
    .int-wrap {
      padding-top: 0;
    }

  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .int-head-text {
      font-size: 1rem;
      margin: 0 auto 1.5rem auto;
    }
    .int-stepper__steps {
      max-width: 18rem;
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .int-logo {
      display: block;
      max-width: 15rem;
      margin: 0 auto;
    }
    .int-head {
      font-size: 1.75rem;
    }
    .int-head-text {
      margin-bottom: 1rem;
    }
  }

</style>
<style lang="scss">
  .int-stepper {
    .v-stepper__step {
      padding: 0;
      &:last-child {
        .v-stepper__step__step {
          margin-right: 0;
        }
      }
    }
    .v-stepper__step__step {
      width: 2.5rem;
      height: 2.5rem;
      font-size: 0.875rem;
      position: relative;
      z-index: 2;
    }
  }
  .theme--light.v-stepper.int-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background-color: #FFFFFF;
    color: #757575;
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .int-stepper .v-stepper__step__step {
      width: 2.25rem;
      height: 2.25rem;
      font-size: 0.875rem;
    }
  }
</style>

<i18n lang="yml" locale="ru">
  title1: Активация аккаунта
  title2: Импорт вакансий
  description1: 'Чтобы начать получать видеоотклики от кандидатов, вам необходимо создать аккаунт в сервисе Huntica.'
  description2: Вакансии с сайта Rabota.ru, для которых вы бы хотели настроить получение видеооткликов.
  next: Далее
</i18n>
